var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbiddenSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dc0032;}.b{fill:#ffce00;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C1-1 korkortonline.se") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M500.2.2c276.14,0,500,223.86,500,500s-223.86,500-500,500S.2,776.34.2,500.2,224.06.2,500.2.2Z",
    transform: "translate(-0.2 -0.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M943.11,596.87a453.42,453.42,0,0,0,0-193.34H57.29a453.42,453.42,0,0,0,0,193.34Z",
    transform: "translate(-0.2 -0.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbiddenSign);
export default __webpack_public_path__ + "static/media/forbidden_sign.4aa82a94e2a955359b3912c06da6ed31.svg";
export { ForwardRef as ReactComponent };